var map = {
	"./banco-de-brasilia.svg": "37ca",
	"./banco-do-brasil-official.svg": "0908",
	"./banco-do-nordeste.svg": "a2eb",
	"./banco-inter.svg": "27b4",
	"./banco-original.svg": "ac60",
	"./banco-real.svg": "7e27",
	"./banco-safra.svg": "4697",
	"./bancoob.svg": "813f",
	"./banestes.svg": "b983",
	"./bankboston.svg": "710b",
	"./banpara.svg": "576b",
	"./banrisul.svg": "dfda",
	"./bcn.svg": "e425",
	"./bradesco.svg": "6727",
	"./caixa.svg": "7053",
	"./citi.svg": "9bd2",
	"./credisan.svg": "5e59",
	"./cresol.svg": "003e",
	"./daycoval.svg": "cbc5",
	"./hsbc.svg": "589c",
	"./itau.svg": "dddc",
	"./logo.svg": "54cd",
	"./mercantil-do-brasil.svg": "a2bb",
	"./nossa-caixa.svg": "a853",
	"./outro-banco.svg": "6d43",
	"./safra.svg": "417c",
	"./santander.svg": "cab4",
	"./sicoob.svg": "dfb6",
	"./sicredi.svg": "5af7",
	"./sudameris.svg": "2cf45",
	"./unibanco.svg": "a5db",
	"./viacredi.svg": "28eb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "700a";